document.addEventListener('keydown', function (event) {
  if (event.key === 'Tab') {
    document.documentElement.classList.remove('user-is-pointing');
  }
}, true);

document.addEventListener('pointerdown', function () {
  document.documentElement.classList.add('user-is-pointing');
}, true);

// Skip to content link
document.addEventListener('DOMContentLoaded', function () {
  const skip = document.createElement('a');
  skip.href = '#main-content';
  skip.className = 'skip-to-content';
  skip.textContent = 'Skip to content';
  document.body.prepend(skip);

  const skip2 = document.querySelector('.skip-to-content');
  if (!skip2) return;
  skip2.setAttribute('tabindex', '0');

  const el = document.querySelector('.fl-builder-content-primary');
  if (el && !el.id) {
    el.id = 'main-content';
  }
});


jQuery(function () {
  jQuery('.dropdown-toggle').click(function (e) {
    e.preventDefault();
    jQuery(this).toggleClass('active');
    jQuery(this).next('.dropdown').toggle();
  });

  jQuery('.dropdown li').click(function (e) {
    var chosen = e.target.innerText;
    console.log(chosen);
    jQuery('.dropdown-toggle').text(chosen);
    jQuery('.dropdown-toggle').removeClass('active');
  });

  jQuery(document).click(function (e) {
    var target = e.target;
    if (!jQuery(target).is('.dropdown-toggle') && !jQuery(target).parents().is('.dropdown-toggle')) {
      jQuery('.dropdown').hide();
    }
  });
});

jQuery(window).on("load", function () {
  var stHeight = jQuery('.Adv-slider .slick-track').height();
  jQuery('.Adv-slider .slick-slide').css('height', stHeight + 'px');
});


jQuery(".sc-go-back a").on("click", function (event) {
  event.preventDefault();

  var homepage = "https://spearcenter.com";

  var referrer = document.referrer;

  if (referrer && referrer.includes("spearcenter")) {
    window.history.back();
  } else {
    window.location.href = homepage;
  }
});


// Parse URL query parameters

jQuery(window).on('load', function () {
  var params = new URLSearchParams(window.location.search);

  if (jQuery('.RequestAppointment-row').length > 0 && jQuery(window).width() < 1280) {
    if (params.has('location_id') || params.has('therapist_id')) {
      var $form = jQuery('.RequestAppointment-row').first();

      if ($form.length) {
        jQuery('html, body').animate({
          scrollTop: $form.offset().top
        }, 500);
      }
    }
  }
});

(function ($) {

  var videoControlSelector = '.ada-video-controls';
  var marqueeControlSelector = '.marquee-motion-control';

  function syncLogoSlideFocus($marquee) {
    $marquee.find('.PPMarquee-item').each(function () {
      var $slide = $(this);
      var hidden = $slide.attr('aria-hidden') === 'true';

      if ($slide.is('[tabindex]')) {
        $slide.removeAttr('tabindex');
      }
      if (this.inert !== hidden) {
        this.inert = hidden;
      }
    });
  }

  $(function () {
    $('.PPMarquee-slick').each(function () {
      var $marquee = $(this);
      new MutationObserver(function () {
        syncLogoSlideFocus($marquee);
      }).observe(this, { subtree: true, attributes: true, attributeFilter: ['aria-hidden', 'tabindex'] });

      $marquee.on('init', function (event, slick) {
        slick.options.accessibility = false;
        syncLogoSlideFocus($marquee);
      });

      if ($marquee.hasClass('slick-initialized') && typeof $.fn.slick === 'function') {
        $marquee.slick('getSlick').options.accessibility = false;
        syncLogoSlideFocus($marquee);
      }
    });
  });
  var videoControlIcons = '<svg class="video-player-icon video-player-icon--play" aria-hidden="true" width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#spear-play-button-clip)"><path d="M15 29.2105C22.8482 29.2105 29.2105 22.8482 29.2105 15C29.2105 7.1517 22.8482 0.789429 15 0.789429C7.1517 0.789429 0.789429 7.1517 0.789429 15C0.789429 22.8482 7.1517 29.2105 15 29.2105Z" stroke="white" stroke-opacity="0.65"/><path d="M19.0576 14.5668C19.3909 14.7593 19.3909 15.2404 19.0576 15.4329L13.3461 18.7304C13.0127 18.9229 12.5961 18.6823 12.5961 18.2974V11.7023C12.5961 11.3174 13.0127 11.0768 13.3461 11.2693L19.0576 14.5668Z" fill="white"/></g><defs><clipPath id="spear-play-button-clip"><path d="M0 15C0 6.71573 6.71573 0 15 0C23.2843 0 30 6.71573 30 15C30 23.2843 23.2843 30 15 30C6.71573 30 0 23.2843 0 15Z" fill="white"/></clipPath></defs></svg><svg class="video-player-icon video-player-icon--pause" aria-hidden="true" width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#spear-pause-button-clip)"><path d="M15 29.2105C22.8482 29.2105 29.2105 22.8482 29.2105 15C29.2105 7.1517 22.8482 0.789429 15 0.789429C7.1517 0.789429 0.789429 7.1517 0.789429 15C0.789429 22.8482 7.1517 29.2105 15 29.2105Z" stroke="white" stroke-opacity="0.65"/><path d="M12.6316 11.0526V18.9473" stroke="white" stroke-opacity="0.65" stroke-width="2" stroke-linecap="round"/><path d="M17.3684 11.0526V18.9473" stroke="white" stroke-opacity="0.65" stroke-width="2" stroke-linecap="round"/></g><defs><clipPath id="spear-pause-button-clip"><path d="M0 15C0 6.71573 6.71573 0 15 0V0C23.2843 0 30 6.71573 30 15V15C30 23.2843 23.2843 30 15 30V30C6.71573 30 0 23.2843 0 15V15Z" fill="white"/></clipPath></defs></svg>';

  function updateVideoControlState($button, videoEl) {
    var isPaused = videoEl.paused;
    var buttonLabel = isPaused ? 'Play background video' : 'Pause background video';

    $button.toggleClass('pause-video', isPaused);
    $button.attr('aria-label', buttonLabel);
    $button.attr('aria-pressed', String(!isPaused));
    $button.find('.screen-reader-text').text(buttonLabel);
  }

  function initAccessibleVideoControls() {
    $(videoControlSelector).each(function () {
      var $wrapper = $(this);
      var $video = $wrapper.find('video').first();

      if (!$video.length || $wrapper.find('.spear-video-toggle').length) {
        return;
      }

      var $videoContainer = $video.closest('.fl-video, .fl-bg-video');
      var $controlTarget = $videoContainer.length ? $videoContainer : $wrapper;
      var videoEl = $video.get(0);
      var $control = $('<div class="spear-video-toggle-wrap"><button type="button" class="spear-video-toggle"><span class="screen-reader-text"></span>' + videoControlIcons + '</button></div>');
      var $button = $control.find('.spear-video-toggle');

      if ($controlTarget.css('position') === 'static') {
        $controlTarget.css('position', 'relative');
      }

      $controlTarget.append($control);
      updateVideoControlState($button, videoEl);

      $button.on('click', function () {
        if (videoEl.paused) {
          var playPromise = videoEl.play();

          if (playPromise && typeof playPromise.then === 'function') {
            playPromise
              .then(function () {
                updateVideoControlState($button, videoEl);
              })
              .catch(function () {
                updateVideoControlState($button, videoEl);
              });
          } else {
            updateVideoControlState($button, videoEl);
          }

          return;
        }

        videoEl.pause();
        updateVideoControlState($button, videoEl);
      });

      $video.on('play pause ended', function () {
        updateVideoControlState($button, videoEl);
      });
    });
  }

  function updateMarqueeControlState($button, isPaused) {
    var buttonLabel = isPaused ? 'Play marquee animation' : 'Pause marquee animation';

    $button.toggleClass('pause-video', isPaused);
    $button.attr('aria-label', buttonLabel);
    $button.attr('aria-pressed', String(!isPaused));
    $button.find('.screen-reader-text').text(buttonLabel);
  }

  function pauseMarquee($marquee) {
    var pausedAnimations = [];
    var track = $marquee.find('.slick-track').get(0);

    $marquee.slick('slickPause');

    if (track && typeof track.getAnimations === 'function') {
      track.getAnimations().forEach(function (animation) {
        if (animation.playState === 'running' || animation.playState === 'pending') {
          animation.pause();
          pausedAnimations.push(animation);
        }
      });
    }

    $marquee.data('spearPausedAnimations', pausedAnimations);
  }

  function playMarquee($marquee) {
    var pausedAnimations = $marquee.data('spearPausedAnimations') || [];

    pausedAnimations.forEach(function (animation) {
      if (animation.playState === 'paused') {
        animation.play();
      }
    });

    $marquee.removeData('spearPausedAnimations');
    $marquee.slick('slickPlay');
  }

  function initAccessibleMarqueeControls() {
    $(marqueeControlSelector).each(function () {
      var $wrapper = $(this);
      var $marquee = $wrapper.find('.SSCMMarquee-slick.slick-initialized, .PPMarquee-slick.slick-initialized').first();

      if (!$marquee.length || $wrapper.find('.spear-marquee-toggle').length) {
        return;
      }

      var isPaused = false;
      var $control = $('<div class="spear-video-toggle-wrap spear-marquee-toggle-wrap"><button type="button" class="spear-video-toggle spear-marquee-toggle"><span class="screen-reader-text"></span>' + videoControlIcons + '</button></div>');
      var $button = $control.find('.spear-marquee-toggle');

      $wrapper.append($control);
      updateMarqueeControlState($button, isPaused);

      $button.on('click', function () {
        isPaused = !isPaused;

        if (isPaused) {
          pauseMarquee($marquee);
        } else {
          playMarquee($marquee);
        }

        updateMarqueeControlState($button, isPaused);
      });
    });
  }

  $(window).on('load', function () {
    initAccessibleVideoControls();
    initAccessibleMarqueeControls();

    $('.SSCMMarquee-fake_slide').removeAttr('tabindex');
  });


  $('.SSCMMarquee-slick').on('afterChange', function () {
    setTimeout(function () {
      $(document).find('.SSCMMarquee-slick .slick-slide').removeAttr('tabindex');
    }, 1);
  });

})(jQuery);
